/**
 * PDP: variant metafield custom.gift_product_handle → show gift + expose map for add-to-cart.
 */
if (!customElements.get('product-gift-with-purchase')) {
  customElements.define(
    'product-gift-with-purchase',
    class ProductGiftWithPurchase extends HTMLElement {
      constructor() {
        super();
        this.map = {};
        this.sectionId = this.dataset.sectionId;
        this._onVariantChange = this._onVariantChange.bind(this);
        this._onFormChange = this._onFormChange.bind(this);
      }

      connectedCallback() {
        const el = document.getElementById(`GiftWithPurchaseMap-${this.sectionId}`);
        if (el) {
          try {
            this.map = JSON.parse(el.textContent) || {};
          } catch (e) {
            this.map = {};
          }
        }
        document.addEventListener('variant:change', this._onVariantChange);
        document.addEventListener('variant-change', this._onVariantChange);
        const form = document.getElementById(`product-form-${this.sectionId}`);
        if (form) {
          form.addEventListener('change', this._onFormChange);
        }
        this._scheduleSyncVariant();
      }

      disconnectedCallback() {
        document.removeEventListener('variant:change', this._onVariantChange);
        document.removeEventListener('variant-change', this._onVariantChange);
        const form = document.getElementById(`product-form-${this.sectionId}`);
        form?.removeEventListener('change', this._onFormChange);
      }

      _onFormChange(e) {
        const t = e.target;
        if (t && t.name === 'id' && t.value) {
          this._updateUi(t.value);
        }
      }

      _scheduleSyncVariant() {
        const sync = () => {
          const form = document.getElementById(`product-form-${this.sectionId}`);
          const vid = form?.querySelector('input[name="id"]')?.value;
          if (vid) this._updateUi(vid);
        };
        queueMicrotask(sync);
        requestAnimationFrame(() => {
          requestAnimationFrame(sync);
        });
        setTimeout(sync, 0);
        setTimeout(sync, 100);
      }

      _onVariantChange(e) {
        const d = e.detail;
        if (!d || String(d.sectionId) !== String(this.sectionId)) return;
        const vid = d.variant?.id || d.variant?.value;
        if (vid) this._updateUi(vid);
      }

      _formatMoney(cents) {
        if (window.Shopify && window.Shopify.formatMoney) {
          const format =
            window.theme?.settings?.moneyFormat ||
            window.theme?.settings?.moneyWithCurrencyFormat ||
            '${{amount}}';
          return window.Shopify.formatMoney(cents, format);
        }
        return `$${(cents / 100).toFixed(2)}`;
      }

      _fillCard(card, gift) {
        const media = card.querySelector('[data-gift-media]');
        const title = card.querySelector('[data-gift-title]');
        const details = card.querySelector('[data-gift-details]');
        const priceRetail = card.querySelector('[data-gift-price-retail]');
        if (title) title.textContent = gift.giftTitle || '';
        if (details) details.href = gift.giftUrl || '#';
        if (media) {
          media.replaceChildren();
          if (gift.giftImage) {
            const img = document.createElement('img');
            img.src = gift.giftImage;
            img.alt = '';
            img.loading = 'lazy';
            img.width = 64;
            img.height = 64;
            media.appendChild(img);
          }
        }
        if (priceRetail) {
          const retail = parseInt(gift.giftPrice, 10) || 0;
          if (retail > 0) {
            priceRetail.hidden = false;
            priceRetail.textContent = this._formatMoney(retail);
          } else {
            priceRetail.hidden = true;
            priceRetail.textContent = '';
          }
        }
      }

      _updateUi(variantId) {
        const key = String(variantId);
        const entry = this.map[key];
        const gifts = entry && Array.isArray(entry.gifts) ? entry.gifts : [];
        const list = this.querySelector('[data-gift-list]');
        const template = this.querySelector('[data-gift-template]');
        const note = this.querySelector('[data-gift-unavailable]');

        if (!gifts.length || !list || !template) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        list.replaceChildren();
        let anyUnavailable = false;
        gifts.forEach((gift) => {
          const fragment = template.content.cloneNode(true);
          this._fillCard(fragment, gift);
          if (!gift.giftAvailable) anyUnavailable = true;
          list.appendChild(fragment);
        });
        if (note) {
          if (anyUnavailable) {
            note.hidden = false;
            note.textContent = window.giftWithPurchaseStrings?.unavailable || '';
          } else {
            note.hidden = true;
          }
        }
      }
    }
  );
}

window.getGiftWithPurchaseEntry = function (sectionId, variantId) {
  const block = document.querySelector(`product-gift-with-purchase[data-section-id="${sectionId}"]`);
  if (!block || !block.map) return null;
  return block.map[String(variantId)] || null;
};
